import React, { useState, useEffect } from "react";
import HomeDashboardLayout from "../HomeDashboardLayout";
import HeaderProfileSection from "../HeaderProfileSection";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "./QuestionPaperList.css";
import heroImg from "../../assets/images/qb1.png";


const questionData = [
  {
    id: 1,
    question: "In C++ a function contained within a class is called",
    hindi:
      "C++ में एक फलन (फंक्शन) जो किसी वर्ग के अंतर्गत निहित हो कहलाता है",
    status: "incorrect",
  },
  {
    id: 2,
    question: "The fields in a class of a C++ program are by default",
    hindi: "किसी C++ प्रोग्राम के एक वर्ग में क्षेत्र पहले से ही होते हैं",
    status: "correct",
  },
  {
    id: 3,
    question: "Which language is used to create macros in Excel ?",
    hindi:
      "एक्सेल में मैक्रोज़ के निर्माण के लिए कौन सी लैंग्वेज प्रयुक्त की जाती है ?",
    status: "null",
  },
  {
    id: 4,
    question: "In C, Modulus operator is used to get",
    hindi: "C में माडुलस ऑपरेटर का उपयोग किया जाता है",
    status: "null",
  },
  {
    id: 5,
    question: "The fastest sorting techniques/algorithm is",
    hindi: "तीव्रतम छंटाई तकनीक/एल्गोरिथ्म है",
    status: "null",
  },
  {
    id: 6,
    question: "A function in C using pointers can return",
    hindi: "C में पॉइंटर का उपयोग करने वाला फ़ंक्शन वापस कर सकता है",
    status: "null",
  },
];

const QbankPaperList = () => {
  return (
    <>
      <style>{`
          .homeDashboard-wrapper .page-content {
            padding-right: 0;
          }
        
      `}</style>
      <HomeDashboardLayout showHeader={false}>
        <div className="qbl-page qbankList-page">
          <div className="qbl-main">
            <section className="qbl-panel">
              <div className="hideProfile-page ">
                {/* Page header */}
                <div className="categories-page-header mb-0">
                  <div>
                    <button type="button" className="categories-back-button">
                      <i className="bi bi-chevron-left"></i>
                    </button>
                  </div>
                  <div></div>
                  <div>
                    <HeaderProfileSection />
                  </div>
                </div>
              </div>

              <div className="qb-body">
                <div className="d-flex align-items-center justify-content-center">
                  <div className="qb-copy">
                    <div className="qb-loc">
                      <span>Himachal Pradesh </span>
                    </div>

                    <h1 className="qb-title">
                      Test & <span> Quizzes </span>
                    </h1>

                    <p className="qb-sub qbb-list">
                      Practice more , score higher{" "}
                    </p>
                  </div>
                </div>
              </div>


                 <div className="question-paper-listt">
                    {questionData.map((item) => (
                        <div className="question-list-cardd" key={item.id}>
                            <div className="question-list-headerr">
                                <span className="question-list-numberr">
                                {String(item.id).padStart(2, "0")}
                                </span>

                                {item.status === "correct" && (
                                <span className="question-status-iconn correct">
                                    <i className="bi bi-check-lg"></i>
                                </span>
                                )}

                                {item.status === "incorrect" && (
                                <span className="question-status-iconn incorrect">
                                    <i className="bi bi-x-lg"></i>
                                </span>
                                )}
                            </div>

                            <div className="question-list-contentt">
                                <p className="question-englishh">{item.question}</p>
                                <p className="question-hindii">{item.hindi}</p>
                            </div>
                        </div>
                    ))}
                    </div>
            </section>
          </div>
        </div>
      </HomeDashboardLayout>
    </>
  );
};

export default QbankPaperList;
